import React from 'react';

import { ChatPage } from '../../utils/chatPage';

const noop = () => {};

const chatContextInitialState = {
  isReady: false,
  firebase: null,
  chatUser: {},
  authUser: null,
  activeChannelId: '',
  focusMessageId: '',
  setFocusMessageId: noop,
  clearFocusMessage: noop,
  currentChatPage: ChatPage.ChannelList,
  setCurrentChatPage: noop,
  mediaRecorder: null,
  channelError: null,
  setChannelError: noop,
  activeUserId: '',
  setActiveUserId: noop,
  logEvent: noop,
  isChatWebViewOpen: false,
  setIsChatWebViewOpen: noop,
  smartContextOpen: true,
  setSmartContextOpen: noop,
  isSmartContextEnabled: false,
  isVoiceNotePilotCoach: false,
};

const ChatContext = React.createContext(chatContextInitialState);

export default ChatContext;
export {
  chatContextInitialState,
};
